import * as React from "react";
import { UitkButtonToggle } from "older-uitk-react-button-toggle";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { LobNavigationItemProps } from "./typings";
import { useLocalization } from "@shared-ui/localization-context";
import { Link } from "react-router-dom";
import { wizardLobQueryParamKey } from "../constants";

const LobNavigationItem = (props: LobNavigationItemProps) => {
  const { formatText } = useLocalization();
  const { flexComponent, isTabChecked, getLabel, getLobIcon, searchParams, handleLobChange, index, lobsLength } = props;
  const { name, model } = flexComponent;
  const ariaLabel = formatText("wizard.lob.tab.alttext", getLabel(name), index + 1, lobsLength);
  const [useLink, setUseLink] = React.useState(true);

  /**
   * This hook is reached for rehydratation, so if JS is enabled there is no need of use a Link component
   * for a hard refresh, so the value is changed to false, if JS is disabled then this hook is never executed
   */
  React.useEffect(() => setUseLink(false), []);

  const whereToGo = () => {
    const { directLink } = model;

    if (directLink) {
      return directLink;
    }

    const searchParam = new URLSearchParams(searchParams);
    searchParam.set(wizardLobQueryParamKey, name);

    return `?${searchParam.toString()}`;
  };

  return (
    <UitkLayoutFlexItem grow={1} className="lobItem all-r-margin-one all-b-margin-six" aria-label={getLabel(name)}>
      <li>
        {useLink ? (
          <Link to={whereToGo()} className="ssr-lob-btn" role="tab" aria-selected={isTabChecked(name)}>
            <UitkButtonToggle checked={isTabChecked(name)} icon={getLobIcon(name)} label={getLabel(name)} name={name} />
          </Link>
        ) : (
          <UitkButtonToggle
            checked={isTabChecked(name)}
            icon={getLobIcon(name)}
            label={getLabel(name)}
            id={name}
            onChange={handleLobChange(name, model)}
            aria-label={ariaLabel}
            aria-selected={isTabChecked(name)}
            role="tab"
          />
        )}
      </li>
    </UitkLayoutFlexItem>
  );
};

export default LobNavigationItem;
